
import type { SVGProps } from 'react';
const SvgSportkurse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#sportkurse_svg__a)">
      <path
        fill="#263E6A"
        d="m19.92 8.624-1.488-1.488.58-.58a.274.274 0 0 0 0-.388l-1.18-1.181a.274.274 0 0 0-.387 0l-.224.224a.274.274 0 0 0 .387.387l.03-.03.794.794-.387.387-2.67-2.669a.274.274 0 0 0-.386 0l-.599.598a.274.274 0 0 0 .387.388l.405-.405 1.487 1.487 1.182 1.182 1.488 1.488-.968.968-.247-.247a.274.274 0 1 0-.387.387l.44.44.35.351-.968.968-5.244-5.244.968-.968.35.35 3.025 3.025a.273.273 0 0 0 .387 0 .274.274 0 0 0 0-.387L14.02 5.436l-.543-.544a.274.274 0 0 0-.388 0l-1.355 1.355a.274.274 0 0 0 0 .387l2.031 2.032-5.1 5.1-2.03-2.032a.274.274 0 0 0-.388 0L4.892 13.09a.274.274 0 0 0 0 .387l.35.35-1.162 1.162a.274.274 0 0 0 0 .387l1.488 1.488-.581.58a.274.274 0 0 0 0 .388l1.181 1.181a.273.273 0 0 0 .387 0l.224-.224a.274.274 0 1 0-.387-.387l-.03.03-.794-.794.387-.387.988.987 1.681 1.682a.273.273 0 0 0 .387 0l.598-.598a.274.274 0 1 0-.387-.387l-.404.404-1.488-1.488-1.181-1.18-1.488-1.489.968-.968.247.247a.274.274 0 0 0 .387-.387l-.44-.44-.35-.35.968-.969 5.244 5.245-.968.968-.35-.35-3.025-3.026a.274.274 0 1 0-.388.388l3.025 3.025.544.543a.273.273 0 0 0 .387 0l1.356-1.355a.274.274 0 0 0 0-.387l-2.032-2.032 4.325-4.325a.274.274 0 0 0-.387-.387l-4.325 4.325-.794-.794 5.1-5.1 3.213 3.213a.27.27 0 0 0 .387 0l1.355-1.355a.274.274 0 0 0 0-.387l-.35-.35 1.162-1.162a.274.274 0 0 0 0-.388"
      />
    </g>
    <defs>
      <clipPath id="sportkurse_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSportkurse;
